module.exports = __webpack_public_path__ + "media/65_Long.158e6d9b.mp3";